import { IProductsCarousel } from './types';
import { CarouselProducts } from '../components/CarouselProducts';
import { ICarouselCard } from '@monofront/types';
import withSlice from '@screens/SlicesContainer/withSlice';
import { mapProductsCarousel } from './mapCarouselProducts';
import { isFilled } from '@prismicio/client';

const ProductsCarousel: React.FC<IProductsCarousel> = ({
  title,
  textLink,
  text,
  items,
  handle,
  trackingId,
  cardTitle,
  cardDescription,
  cardLinkLabel,
  cardLink,
  cardBackgroundColor,
  cardIllustration,
  cardTrackingId,
  position,
}) => {
  let card: ICarouselCard | undefined = undefined;

  if (cardTitle || cardDescription) {
    card = {
      title: cardTitle,
      description: cardDescription,
      label: cardLinkLabel,
      link: cardLink,
      backgroundColor: cardBackgroundColor,
      illustration: isFilled.image(cardIllustration) ? cardIllustration : null,
      trackingId: cardTrackingId,
    };
  }

  return (
    <CarouselProducts
      card={card}
      content={{ title, textLink, text, items, handle, trackingId }}
      position={position}
    />
  );
};

export default withSlice(ProductsCarousel, mapProductsCarousel);
